<div class="p-modal-head06">
  <h1 id="modalTitle" class="p-modal-head06__title" [innerHTML]="'label.inputCustomerInformation' | staticMsg"></h1>
  <!--パーツ(1)：閉じるボタン-->
  <button
    id="passenger-information-request-header-button1"
    class="p-modal-head06__close js-modal-close"
    (click)="clickCloseModal()"
  >
    <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
  </button>
</div>
